export default "/images/vendor/flag-icons/flags/1x1/sm.svg?7f0fe9fe91337a9068532afe61280f7c";